import { render, staticRenderFns } from "./managedLists.vue?vue&type=template&id=213ff70d&scoped=true&"
import script from "./managedLists.vue?vue&type=script&lang=js&"
export * from "./managedLists.vue?vue&type=script&lang=js&"
import style0 from "./managedLists.vue?vue&type=style&index=0&id=213ff70d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "213ff70d",
  null
  
)

export default component.exports